import {
  Box,
  Button,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/core";
import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import LinkedIn from "../../../static/assets/icons/LI-In-Bug.png";

function Login() {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  return (
    <Box p="5">
      <Text fontSize="xl">Login Here</Text>
      <Stack marginY="1em">
        <Input placeholder="Username" />
        <InputGroup>
          <Input
            type={show ? "text" : "password"}
            placeholder="Enter Password"
          />
          <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClick}>
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
      </Stack>
      <SimpleGrid minChildWidth="120px" spacing="1em">
        <Button>Log In</Button>
        <Button variant="outline">
          Login with
          <Image marginLeft="0.25em" size="20px" src={LinkedIn} />
        </Button>
      </SimpleGrid>
      <Stack textAlign="right" marginY="1em">
        <RouterLink style={{ textDecoration: "underline" }} to="">
          Forgot Your Password ?
        </RouterLink>
        <Text textAlign="center" marginY="1em">
          Please write to us at <Link color="#0000b3">info@quiklyy.com</Link> if
          you have face any issues in posting jobs on the site
        </Text>
      </Stack>
    </Box>
  );
}

export default Login;
